import { TextStyle_TextAlignment } from './../../ricos-schema/legacy/wix/rich_content/v1';

const textAlignmentValues = Object.values(TextStyle_TextAlignment);

export function isTextAlignmentStyle(value: unknown): value is TextStyle_TextAlignment {
  return textAlignmentValues.includes(value as TextStyle_TextAlignment);
}
